export interface IModeMilestone {
    submitted: string;
    ready: string;
    accepted: string;
    rejected: string;
    expired: string;
}

export class ModeMilestone implements IModeMilestone {
    submitted: string;
    ready: string;
    accepted: string;
    rejected: string;
    expired: string;

    constructor( current?: IModeMilestone ) {
        this.submitted = current?.submitted || '';
        this.ready = current?.ready || '';
        this.accepted = current?.accepted || '';
        this.rejected = current?.rejected || '';
        this.expired = current?.expired || '';
    }
}
